module.exports = __webpack_public_path__ + "static/img/scene6.f28a74f4.jpg";